export default __webpack_public_path__ + "static/media/282.8e012d8a.jpg";